// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { Locale } from 'jsw';
import apolloClient from '../apolloClient';
import { PasswordEstimation } from 'schema';

import PASSWORD_ESTIMATION_QUERY from 'queries/PasswordEstimation.graphql';

const defaultEstimateFn = async (password: string, userInputs: string[]) => {
    const { data: { passwordEstimation } } = await apolloClient.query({
        query: PASSWORD_ESTIMATION_QUERY,
        variables: { password, userInputs },
    });
    return passwordEstimation;
};

type PasswordStrength = {
    password: string;
    strength: string;
    suggestions: string[];
}

export default async (
    password: string,
    userInputs: string[] = [],
    estimateFn: (password: string, userInputs: string[]) => Promise<PasswordEstimation> = defaultEstimateFn,
): Promise<PasswordStrength> => {
    const [{ level, suggestions }, locale] = await Promise.all([
        estimateFn(password, userInputs ?? []),
        Locale.loadSection('components.password.suggestions'),
    ]);

    return {
        password,
        strength: ['VeryWeak', 'Weak', 'Medium', 'Strong'][level] ?? 'VeryStrong',
        suggestions: suggestions.map((suggestion: string) => locale.lmsg(suggestion)),
    };
};
